<template>
  <a-card class="todo-container" :bordered="false" :body-style="{padding: '10px'}"
          :title="$t('message.views.workbench.toDeliver')">
    <a-table :columns="toShipColumn" :data-source="toShipData" size="small" :border="none"
             :pagination="shipPagination" @change="getShipData">
      <a slot="action" slot-scope="text, record" @click="showShipModal(record)">{{ $t('message.views.workbench.deliver') }}</a>
    </a-table>
    <a-modal v-model="shipVisible" :title="$t('message.menu.shipConfirm')" @ok="handleSubmit">
      <template>
        <div>
          <a-form :form="form1" @submit="handleSubmit">
            <a-form-item :label="$t('message.drawer.fulfillment.trackingNumbers')">
              <a-input v-decorator="['trackingNumbers', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputTrackingNumber') }] }]" v-model="trackingNumber"/>
            </a-form-item>

            <a-form-item :label="$t('message.drawer.fulfillment.shippingName')">
              <a-input
                v-decorator="['shippingName', { rules: [{ required: true, message: this.$t('message.form.fulfillment.inputShippingName') }] }]"
                v-model="shippingName"/>
            </a-form-item>
          </a-form>
        </div>
      </template>
    </a-modal>
  </a-card>
</template>

<script>
import request from '../../../utils/request'
import {OrderApi} from '../../../js/OrderApi'
import Form from 'ant-design-vue/lib/form'
import {ChartCard} from '../../../components'

export default {
  name: 'ToDeliver',
  components: {
    ChartCard
  },
  data () {
    return {
      toShipData: [],
      shipPagination: {
        defaultPageSize: 5,
        current: 1,
        pageSize: 5,
        total: 0,
        onChange: current => {
          // 切换分页时的回调，
          this.shipPagination.current = current
          this.getShipData()
        }
      },
      shipVisible: false
    }
  },
  computed: {
    toShipColumn () {
      return [{
        title: this.$t('message.views.workbench.fulfillmentOrderId'),
        dataIndex: 'orderFulfillmentOrderId',
        scopedSlots: {customRender: 'orderFulfillmentOrderId'},
        ellipsis: true
      }, {
        dataIndex: 'fulfillmentOrderItemId',
        title: this.$t('message.views.workbench.fulfillmentOrderItemId'),
        ellipsis: true
      }, {
        dataIndex: 'merchantCode',
        title: this.$t('message.views.workbench.merchantCode'),
        ellipsis: true
      }, {
        align: 'center',
        key: 'action',
        title: this.$t('message.views.workbench.operation'),
        scopedSlots: {customRender: 'action'},
        ellipsis: true
      }]
    }
  },
  beforeCreate () {
    this.form1 = Form.createForm(this, 'filter-form1')
  },
  mounted () {
    this.getShipData()
  },
  methods: {
    getShipData () {
      request({
        url: OrderApi.OrderFromUrl.queryFulfillmentOrderUrl,
        method: 'get',
        params: {
          orderStatus: 100,
          pageSize: 5,
          pageIndex: this.shipPagination.current
        }
      }).then(response => {
        if (response.data.success) {
          this.toShipData = response.data.data
          this.shipPagination.total = response.data.totalCount
        } else {
          this.$message.error(response.data.errorMsg)
        }
      })
    },
    showShipModal (record) {
      this.fulfillmentOrderId = record.orderFulfillmentOrderId
      this.fulfillmentOrderItemId = record.fulfillmentOrderItemId
      this.merchantCode = record.merchantCode
      this.shipVisible = true
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form1.validateFields((err, values) => {
        if (!err) {
          console.log('Received values of form: ', values)
          this.shipFulfillmentOrder()
        }
      })
    },
    shipFulfillmentOrder () {
      request({
        url: OrderApi.OrderFromUrl.shipAeFulfillmentOrder,
        method: 'post',
        params: {
          fulfillmentOrderId: this.fulfillmentOrderId,
          fulfillmentOrderItemId: this.fulfillmentOrderItemId,
          trackingNumber: this.trackingNumber,
          shippingName: this.shippingName,
          event: this.drawShippingType,
          merchantCode: this.merchantCode
        }
      }).then(response => {
        if (response.data.success) {
          if (response.data.data) {
            this.$message.info('shipping success')
            this.shipVisible = false
          }
        } else {
          this.$message.error(response.data.errorMsg)
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Dashboard/components/ToDeliver.vue